import { useState } from 'react';

import { initializeIcons } from './initializeIcons';
import { registerCustomIcons } from './registerCustomIcons';

let iconsPrepared = false;

type UsePrepareIcons = () => void;
export const usePrepareIcons: UsePrepareIcons = () => {
  useState(() => {
    if (!iconsPrepared) {
      registerCustomIcons();
      initializeIcons();
      iconsPrepared = true;
    }

    return true;
  });
};
